import { Module } from 'vuex';
import { getters } from './getters';
import { createActions } from './actions';
import { mutations } from './mutations';
import { RootState } from '../types';
import { MiniTableState } from './types';
import Bff from '@/api/bff';

export const state: MiniTableState = {};

export function create(bff: Bff): Module<MiniTableState, RootState> {
  const actions = createActions(bff);
  return {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };
}

export const name = 'miniTableModule';
